import { cityMixin } from "@mixin/city";
export default {
  name: "cityPageCity",
  mixins: [cityMixin]
};